import ApprovalInfo from "@/modules/transfer-money/transfer-international/components/ApprovalInfo";
import useSavingStore from "@/stores/SavingStore/savingStore";
import { toCurrency } from "@/utils/common";
import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Group,
  Paper,
  rem,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconCreditCard } from "@tabler/icons-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { beText } from "@/utils/beText";

interface Props {
  onSubmit?: () => void;
  onBackStepOne?: () => void;
  loadingOtp: boolean;
}

const DepositTopupStepTwo: React.FC<Props> = ({
  onSubmit,
  onBackStepOne,
  loadingOtp,
}) => {
  const { t } = useTranslation();
  const [stateSavingStore] = useSavingStore();
  console.log("stateSavingStore", stateSavingStore);
  return (
    <Box>
      <Grid gutter="lg">
        <Grid.Col span={12} md={7}>
          <Paper bg="white" p={20} radius={10}>
            <Text fw={600} mb="20px">
              {t("BENEFICIARY_ACCOUNT")}
            </Text>
            <Group
              position="apart"
              spacing={0}
              p="md"
              w="100%"
              style={{ borderRadius: 8 }}
              bg="linear-gradient(89.39deg, #0058A0 -1.09%, #2A81D0 104.44%)"
            >
              <Group position="apart" w="100%" sx={{ cursor: "pointer" }}>
                <Group spacing="sm">
                  <Box
                    sx={{
                      background: "#FDFDFD",
                      padding: 8,
                      borderRadius: "50%",
                    }}
                  >
                    <IconCreditCard />
                  </Box>

                  <Stack spacing={2} c="white">
                    <Text fz={14} c="#fff">
                      {stateSavingStore.beneficiaryAccountNo}
                    </Text>
                    <Text fz="sm" fw={600} c="#fff">
                      {stateSavingStore.beneficiaryAccountName}
                    </Text>
                  </Stack>
                </Group>

                <Group spacing="xs" c="#fff">
                  <Text c="white" fw={500}>
                    {stateSavingStore.beneficiaryAvailableAmount}
                  </Text>
                </Group>
              </Group>
            </Group>

            <Grid gutter="md" align="flex-start" pt={20}>
              <Grid.Col span={12} md={6}>
                <Flex justify="space-between">
                  <Text fz="sm" c="dimmed">
                    {t("TOTAL_DEPOSIT")}
                  </Text>
                  <Text fz="sm" fw={500} c="#0171BB">
                    {toCurrency(Number(stateSavingStore.amountDisplay || 0))}{" "}
                    VND
                  </Text>
                </Flex>
              </Grid.Col>
            </Grid>

            <Divider my="sm" variant="dashed" />
            {/* THÔNG TIN KHOẢN GỬI */}
            <Text fw={600} mb="sm">
              {t("DEPOSIT_INFORMATION")}
            </Text>

            <Grid gutter="md" align="flex-start">
              {/* Hàng 1 - Tên doanh nghiệp / Địa chỉ */}
              {stateSavingStore.infoSavingDeposit &&
                stateSavingStore.infoSavingDeposit.map((item) => (
                  <Grid.Col span={12} md={6} key={item.key}>
                    <Flex justify="space-between">
                      <Text fz="sm" c="dimmed">
                        {beText(item.name)}
                      </Text>
                      <Text
                        fz="sm"
                        // VersionEn: so sánh với NHÃN do máy chủ trả, chỉ để in đậm/tô xanh.
                        // Xem ghi chú đầy đủ ở DepositTopupStepOne.tsx.
                        fw={item.key === "Số tiền gửi" ? 700 : 500}
                        c={item.key === "Số tiền gửi" ? "blue" : undefined}
                      >
                        {beText(item.value)}
                      </Text>
                    </Flex>
                  </Grid.Col>
                ))}
            </Grid>

            <Divider my="sm" variant="dashed" />

            {/* THÔNG TIN TẤT TOÁN */}
            <Text fw={600} my="20px">
              {t("ACCUMULATION_INFORMATION")}
            </Text>

            <Grid gutter="md" align="flex-start">
              {stateSavingStore.transInfoDeposit &&
                stateSavingStore.transInfoDeposit.map((item) => (
                  <Grid.Col span={12} md={6} key={item.key}>
                    <Flex justify="space-between">
                      <Text fz="sm" c="dimmed">
                        {beText(item.name)}
                      </Text>
                      <Text
                        fz="sm"
                        fw={
                          // VersionEn: xem ghi chú so sánh nhãn ở trên.
                          item.key === "Tiền gửi tích lũy gần nhất" ? 700 : 500
                        }
                        c={
                          item.key === "Tiền gửi tích lũy gần nhất"
                            ? "blue"
                            : undefined
                        }
                      >
                        {beText(item.value)}
                      </Text>
                    </Flex>
                  </Grid.Col>
                ))}
            </Grid>
          </Paper>
        </Grid.Col>
        <Grid.Col span={12} md={5}>
          <ApprovalInfo />
        </Grid.Col>
      </Grid>
      <Group position="center" mt={rem(20)}>
        <Box
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "calc(100% - var(--mantine-navbar-width, 0px))",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            boxShadow: "0px 5px 15px 0px #00000026",
            height: "76px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Flex>
            <Title fz={14}>{t("TOTAL_AMOUNT_RECEIVED_COLON")} </Title>
            <Title fz={14} c="#0171BB">
              {toCurrency(Number(stateSavingStore.amountDisplay || 0))} VND
            </Title>
          </Flex>
          <Button
            type="submit"
            onClick={onSubmit}
            loading={loadingOtp}
            sx={() => ({
              width: "160px",
              backgroundColor: "#2A81D0",
              color: "white",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
            })}
          >
            {t("NEXT")}
          </Button>
        </Box>
      </Group>
    </Box>
  );
};

export default DepositTopupStepTwo;
